import { customerClient } from "../../api/customersClient";
import {
	RETURN_CUSTOMER_CODE,
  RETURN_CUSTOMER_CODE_FAIL,
	ReturnCustomerCodeType,
  Customer
  } from "../../domain/trustPicker/index";
import { initialState } from "../../../Common/reducers";

  // in actions folder
  export const returnCustomerCodeAction = (result:  Customer[]): ReturnCustomerCodeType => {
	return {
	  type: RETURN_CUSTOMER_CODE,
	  payload: result,
	};
  };
   
  export const returnCustomerCodeFailAction = (err:  Customer[]): ReturnCustomerCodeType  => {
	return {
	  type: RETURN_CUSTOMER_CODE_FAIL,
	  payload: err,
	};
  };

export const handleReturnCustomerCodes = (token: string, connection: string) => {
    return function (dispatch:any) {
      const endpoint = new customerClient();
      endpoint.getCustomersForRequestedConnection(token, connection)
      .then((data) => {        
        if(!data.isValid){
          dispatch(returnCustomerCodeFailAction(initialState.trustPicker.result));
          return initialState.trustPicker.result;
        } 

        let customerCodesJson = JSON.parse(JSON.stringify(data));
        let customerCodesData = customerCodesJson["data"];
        let codesJson = customerCodesData["codes"];
        let codes = codesJson.map((code: any) => 
              <Customer>{
              id: code,
              label: code
            });   
        dispatch(returnCustomerCodeAction(codes));
        return codes;
      })
      .catch((err) => {        
        console.log(err);
        dispatch(returnCustomerCodeFailAction(initialState.trustPicker.result)); 
      });
    };
  };